import { render, staticRenderFns } from "./popup-show-box.vue?vue&type=template&id=5c612577&scoped=true&"
import script from "./popup-show-box.vue?vue&type=script&lang=js&"
export * from "./popup-show-box.vue?vue&type=script&lang=js&"
import style0 from "./popup-show-box.vue?vue&type=style&index=0&id=5c612577&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c612577",
  null
  
)

export default component.exports